import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-fines-rep",
  templateUrl: "./fines-rep.component.html",
  styleUrls: ["./fines-rep.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FinesRepComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
